import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button, PhoneIcon, EmailIcon, MapIcon } from '../../components';
import { StyledContactCard } from './styles';

export const ContactCard = ({ contact, ...props }) => {
  return (
    <StyledContactCard {...props}>
      <h2>Westcoast Bullion Office</h2>
      <address>
        {contact.address}
        <br />
        {contact.city}, {contact.province} {contact.postalCode}
      </address>
      <Button
        styleType="link"
        icon={<MapIcon />}
        gutter={{ bottom: '2rem' }}
        href="https://goo.gl/maps/N1XGey7hV2Q9gtgG9"
        target="_blank"
        rel="nofollow noreferrer noopener">
        Get Google map directions
      </Button>
      <h2>Reach us directly</h2>
      <div>
        <Button
          styleType="link"
          icon={<PhoneIcon />}
          href={`tel:${contact.phone}`}>
          Call {contact.phone}
        </Button>
      </div>
      <div>
        <Button
          styleType="link"
          icon={<PhoneIcon />}
          href={`tel:${contact.mobile}`}>
          Mobile {contact.mobile}
        </Button>
      </div>
      <div>
      <Button
          styleType="link"
          icon={<EmailIcon />}
          href={`mailto:${contact.email}`}>
          {contact.email}
        </Button>
      </div>
    </StyledContactCard>
  );
};

ContactCard.propTypes = {
  contact: PropTypes.object.isRequired,
};
